import createStyles from "@mui/styles/createStyles";
export const useStyles = (theme) =>
  createStyles({
    containter: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    border: {
      border: "1px solid #f3f3f3;",
      borderRadius: "8px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    formGroup: {
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(1),
        width: "auto",
      },
      [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(1),
        width: "auto",
      },
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(1, 0),
        width: "100%",
      },
    },
    minHeight: {
      // height: "74vh",
    },
  });
